import { api } from '../../../api/client';
import { simulationApi } from '../../developer-cockpit/services/simulationApi';
import type { DemoSchool, SimulationActor } from '../../developer-cockpit/types';

export type { DemoSchool, SimulationActor };

export interface LiveFeedItem {
  id: string;
  tipo: 'RFID_ENTRADA' | 'RFID_SAIDA' | 'CHAMADA_CONCLUIDA' | 'CHAMADA_ABERTA' | 'AUSENCIA';
  label: string;
  sublabel: string;
  ts: string;
  cor: 'green' | 'blue' | 'violet' | 'yellow' | 'red';
}

export interface LiveStats {
  totalAlunos: number;
  presentesHoje: number;
  ausentesHoje: number;
  presencaPct: number;
  chamadasHoje: number;
  chamadasConcluidas: number;
  notifHoje: number;
  atualizadoEm: string;
}

export const simStudioApi = {
  // Re-exports do simulationApi existente
  getDemoSchools: simulationApi.getDemoSchools,
  getSchoolActors: simulationApi.getSchoolActors,
  executeDemoSeed: simulationApi.executeDemoSeed,
  activateLiveScenario: (escolaId: string) =>
    api.post(`/simulation/schools/${escolaId}/live-scenario`).then(r => r.data),
  discardSchool: (escolaId: string) =>
    api.delete(`/simulation/schools/${escolaId}`).then(r => r.data),

  // Novos endpoints /sim Studio
  getLiveFeed: async (escolaId: string): Promise<LiveFeedItem[]> => {
    const { data } = await api.get<LiveFeedItem[]>(`/simulation/live-feed?escolaId=${escolaId}`);
    return data;
  },

  getLiveStats: async (escolaId: string): Promise<LiveStats> => {
    const { data } = await api.get<LiveStats>(`/simulation/live-stats?escolaId=${escolaId}`);
    return data;
  },

  getAtoresFixos: async (): Promise<SimulationActor[]> => {
    const { data } = await api.get<any>('/simulation/atores-fixos');
    // O backend retorna { professores: [...], responsaveis: [...] }
    if (Array.isArray(data)) return data;
    const profs: SimulationActor[] = (data?.professores ?? []).map((p: any) => ({
      ...p,
      perfil: p.perfil ?? 'PROFESSOR',
    }));
    const resps: SimulationActor[] = (data?.responsaveis ?? []).map((r: any) => ({
      ...r,
      perfil: 'RESPONSAVEL',
    }));
    return [...profs, ...resps];
  },
};
